// Username plausibility for the homepage "just joined" toast.
// Keep this conservative: a junk-looking name is worse than an empty corner.

const KEYBOARD_JUNK_SEQUENCES = ["asdf", "qwer", "zxcv", "hjkl", "jkl"];
// GET /public/recent-signups substitutes "Player" when a nickname is missing,
// and a canned name in the toast reads as invented social proof.
const PLACEHOLDER_NAMES = new Set(["player", "user", "guest", "unknown", "anonymous"]);
const VOWELS = /[aeiouy]/i;
const LETTER = /[a-z]/i;
const VOWEL_CHARS = new Set(["a", "e", "i", "o", "u", "y"]);

function hasThreeIdenticalRun(value) {
  return /(.)\1{2,}/.test(value);
}

function hasFourConsecutiveConsonants(value) {
  let run = 0;
  for (const char of value.toLowerCase()) {
    if (!LETTER.test(char)) {
      run = 0;
      continue;
    }
    if (VOWEL_CHARS.has(char)) {
      run = 0;
      continue;
    }
    run += 1;
    if (run >= 4) return true;
  }
  return false;
}

function hasKeyboardJunkSequence(value) {
  const lower = value.toLowerCase();
  return KEYBOARD_JUNK_SEQUENCES.some((sequence) => lower.includes(sequence));
}

export function isPlausibleUsername(username) {
  if (typeof username !== "string") return false;
  const value = username.trim();
  if (value.length < 3 || value.length > 20) return false;
  if (/^\d+$/.test(value)) return false;
  if (PLACEHOLDER_NAMES.has(value.toLowerCase())) return false;
  if (!VOWELS.test(value)) return false;
  if (hasThreeIdenticalRun(value)) return false;
  if (hasFourConsecutiveConsonants(value)) return false;
  if (hasKeyboardJunkSequence(value)) return false;
  return true;
}
